module.exports = __webpack_public_path__ + "8d5c9f58f36e1a71a0aa8f295dd3693f.MP3";